export default "<app-header *ngIf=\"userAccess\"></app-header>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>"